import { CircularProgress, Grid, Typography } from "@mui/material"


export interface LoadingProps {
  loadingMessage?: string;
};

export const Loading = (props: LoadingProps) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        minHeight: '100vh', // make it fill the whole screen
      })}
      spacing={2}
    >
      {props.loadingMessage && (
        <Typography variant="h6" color="textPrimary">
          {props.loadingMessage}
        </Typography>
      )}
      <CircularProgress />
    </Grid>
  )
}